// extracted by mini-css-extract-plugin
export default {"container":"bq-z","brandName":"cq-z","productName":"dq-z","productNamePdpEnhancements":"eq-z","breakLongProductName":"fq-z"};